//
// TableElement.js
// BIRD
//
// Generated by Robots v0.
// Copyright (c) SAS Institute Inc. All rights reserved.
//
// DO NOT EDIT THIS FILE. IT IS GENERATED BY ROBOTS.
//
// Disable camelcase rule for generated code.
/* eslint-disable camelcase */
import { createModule } from "@sas-dvr/ltjs-commons/moduleBuilder";
import EventDispatcher from "@sas-dvr/ltjs-commons/events/EventDispatcher";
import "../../lib";
import "./VisualElement";
import "../dataDefinition/DataDefinition";
import "./table/TableReplicate";
import "@sas-dvr/ltjs-commons/util/Dimension";
import "./table/TableColumnSizing";
import "./table/TableLabel";
import "./table/TableSummary";
import "./table/TableColumns";
import "./table/TableRows";
import "./RowNumbers";

var TableElement = createModule("BIRD::TableElement", ["commons::PropertyOwner","commons::BaseModel","BIRD::BIRDModel","BIRD::VisualElement"], EventDispatcher, [
    ,
    {
        summary: 1,
        replicate: 4,
        frozenColumnCount: 4,
        columns: 1,
        primaryDataDefinition: 1,
        rows: 1,
        aggregate: 2,
        labels: [1],
        presentation: 7,
        cellSpacing: 1,
        rowNumbers: 1,
        columnSizing: 4,
        cellPadding: 1,
    },
    ,
    ,
    ,
    {
        _create: [4],
    },
    ,
]);
export default TableElement;
